<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-card dark rounded="xxl" elevation="24" width="300">
        <div class="text-center text-h5 mt-4">Вход</div>
        <v-card-text>
          <v-form
              class="px-3"
              ref="form"
              lazy-validation
          >
            <v-text-field
                color="green"
                outlined
                autofocus
                v-model="login"
                label="login"
                type="text"
                autocomplete="false"
            ></v-text-field>
            <v-text-field
                color="green"
                outlined
                v-model="password"
                label="password"
                type="password"
                autocomplete="false"
            ></v-text-field>
          </v-form>
          <v-card-actions>
            <v-btn
                large
                width="100%"
                dark
                color="black"
                @click="sendLogin()"
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
  name: 'LoginView',
  data: () => ({
    login: null,
    password: null
  }),
  watch: {
    user: {
      handler (v) {
        if (v.id) {
          this.$router.push('dashboard/catalog')
        }
      }
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('auth', ['loginRequest', 'getUser']),
    sendLogin () {
      const promise = this.loginRequest({
        email: this.login,
        password: this.password
      })

      promise.then(r => {
        this.$router.push('/dashboard/catalog')
      })
    }
  },
  created () {
    if (localStorage.getItem('token')) {
      this.getUser().then(res => {
        this.$router.push('/dashboard/catalog')
      })
    }
  }
}
</script>

<style>

</style>
